import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export const WaitlistForm = () => {
  const [f, setF] = useState({ name: "", email: "", company: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/waitlist", f);
      setDone(true);
    } catch (ex) {
      setErr(errMsg(ex));
    }
  };
  if (done) {
    return (
      <div className="text-center py-6" data-testid="waitlist-success">
        <CheckCircle2 className="mx-auto text-qi-emerald" size={40} />
        <p className="font-display text-xl font-bold mt-3">You're on the list</p>
        <p className="text-sm text-white/50 mt-1">We'll reach out as soon as paid listings open.</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="space-y-3">
      <input required placeholder="Your name" className="field" value={f.name} onChange={set("name")} data-testid="waitlist-name-input" />
      <input required type="email" placeholder="Email" className="field" value={f.email} onChange={set("email")} data-testid="waitlist-email-input" />
      <input placeholder="Company" className="field" value={f.company} onChange={set("company")} data-testid="waitlist-company-input" />
      {err && <p className="text-sm text-red-400">{err}</p>}
      <button className="btn-pink w-full" data-testid="waitlist-submit-button">Join the waitlist</button>
    </form>
  );
};

export default function Waitlist() {
  return (
    <div className="max-w-xl mx-auto px-6 py-20" data-testid="waitlist-page">
      <span className="eyebrow">Paid plan · coming soon</span>
      <h1 className="font-display text-4xl font-black tracking-tight mt-4">Join the listing waitlist</h1>
      <p className="text-white/55 mt-3">Once all 30 free founding spots are claimed, new intermediaries can reserve a place for our upcoming paid plan.</p>
      <div className="glass-card p-8 mt-8"><WaitlistForm /></div>
    </div>
  );
}
